import {
    EDITMAPPINGLANGUAGELISTADMIN_SUCCESS,
    EDITMAPPINGLANGUAGELISTADMIN_FAILED,
    RESET_EDITMAPPINGLANGUAGELISTADMIN,
    LOADING_EDITMAPPINGLANGUAGELISTADMIN,
    NETWORK_ERROR_EDITMAPPINGLANGUAGELISTADMIN
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_EDITMAPPINGLANGUAGELISTADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case EDITMAPPINGLANGUAGELISTADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case EDITMAPPINGLANGUAGELISTADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_EDITMAPPINGLANGUAGELISTADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_EDITMAPPINGLANGUAGELISTADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
